export const FEATURE = {
  TRACKING_NAV: 'tracking-nav',
  SCHEDULES_NAV: 'schedules-nav',
  SCHEDULES_BANNER: 'schedules-banner',
} as const;
